import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

import Helper from "../../helper";
import Appconfig from "../../config/config";
import { casinoGames } from "../CasinoImageGrid/CasinoImageGrid";
import "./DesktopCasino.css";

const providerTabs = [
  { id: "all", label: "ALL" },
  { id: "fantasy11", label: "FANTASY11" },
  { id: "mac88-live", label: "MAC88 LIVE" },
  { id: "mac88-fun-games", label: "MAC88 FUN GAMES" },
  { id: "mac88-virtuals", label: "MAC88 VIRTUALS" },
  { id: "mac88-live-prediction", label: "MAC88 LIVE PREDICTION" },
  { id: "macsexy", label: "MACSEXY" },
  { id: "color", label: "COLOR AND CHICKEN GAMES" },
  { id: "turbo-games", label: "TURBO GAMES" },
  { id: "ezugi", label: "EZUGI GAMING" },
  { id: "jili", label: "JILI" },
  { id: "bikni", label: "BIKNI GAMES" },
  { id: "gamzix", label: "GAMZIX" },
  { id: "betgames", label: "BETGAMES" },
  { id: "king-midas", label: "KING MIDAS" },
  { id: "tristar", label: "TRISTAR" },
  { id: "creedroomz", label: "CREEDROOMZ" },
  { id: "smartsoft", label: "SMARTSOFT" },
  { id: "evolution", label: "EVOLUTION" },
  { id: "evoplay-entertainment", label: "EVOPLAY ENTERTAINMENT" },
  { id: "spribe", label: "SPRIBE" },
  { id: "popok", label: "POPOK" },
  { id: "pascal", label: "PASCAL" },
  { id: "marble", label: "MARBLE" },
  { id: "sexy", label: "SEXY" },
  { id: "million-games", label: "MILLION GAMES" },
  { id: "mac-excite", label: "MAC EXCITE" },
  { id: "cock-fight", label: "COCK FIGHT" },
  { id: "insta-live", label: "INSTA LIVE" },
  { id: "predix", label: "PREDIX" },
  { id: "worli-matka", label: "WORLI MATKA" },
];

const gameTypeTabsByProvider = {
  all: [
    { id: "others", label: "OTHERS" },
    { id: "dragon-tiger", label: "DRAGON TIGER" },
    { id: "lightning", label: "LIGHTNING" },
    { id: "teenpatti", label: "TEENPATTI" },
    { id: "baccarat", label: "BACCARAT" },
    { id: "sicbo", label: "SICBO" },
    { id: "lucky7", label: "LUCKY7" },
    { id: "roulette", label: "ROULETTE" },
    { id: "poker", label: "POKER" },
    { id: "andar-bahar", label: "ANDARBAHAR" },
    { id: "32-cards", label: "32 CARDS" },
    { id: "lottery", label: "LOTTERY" },
    { id: "cricket-war", label: "CRICKETWAR" },
    { id: "hi-low", label: "HI LOW" },
    { id: "live-game-show", label: "LIVE GAME SHOW" },
    { id: "aviator", label: "AVIATOR" },
    { id: "crash", label: "CRASH" },
    { id: "fun-games", label: "FUN GAMES" },
    { id: "slots", label: "SLOTS" },
    { id: "mines", label: "MINES" },
    { id: "blackjack", label: "BLACKJACK" },
    { id: "rummy", label: "RUMMY" },
    { id: "virtual", label: "VIRTUAL" },
    { id: "live", label: "LIVE" },
    { id: "amar-akbar-anthony", label: "AMAR AKBAR ANTHONY" },
    { id: "chicken-games", label: "CHICKEN GAMES" },
    { id: "color-prediction", label: "COLOR PREDICTION" },
    { id: "casual-games", label: "CASUAL GAMES" },
    { id: "crash-instant-game", label: "CRASH_INSTANT GAME" },
    { id: "casino-bingo", label: "CASINO BINGO" },
    { id: "lightining-baccarat", label: "LIGHTNING BACCARAT" },
    { id: "matching-lace", label: "MATCHING LACE" },
    { id: "football-goddess", label: "FOOTBALL GODDESS" },
    { id: "lucky-lace", label: "LUCKY LACE" },
    { id: "fastgames", label: "FASTGAMES" },
    { id: "live-baccarat", label: "LIVE BACCARAT" },
    { id: "turbogames", label: "TURBOGAMES" },
    { id: "crash-type", label: "CRASH TYPE" },
    { id: "video-slots", label: "VIDEO SLOTS" },
    { id: "crash-games", label: "CRASH GAMES" },
    { id: "classic", label: "CLASSIC" },
    { id: "crazy-pachinko", label: "CRAZY PACHINKO" },
    { id: "scratch-cards", label: "SCRATCH CARDS" },
    { id: "video-poker", label: "VIDEO POKER" },
    { id: "slot", label: "SLOT" },
    { id: "instant-game", label: "INSTANT-GAME" },
    { id: "card-game", label: "CARD GAME" },
    { id: "prediction", label: "PREDICTION" },
    { id: "elcasino", label: "ELCASINO" },
  ],

  fantasy11: [
    { id: "all", label: "ALL" },
    { id: "others", label: "OTHERS" },
  ],

  "mac88-live": [
    { id: "others", label: "OTHERS" },
    { id: "dragon-tiger", label: "DRAGON TIGER" },
    { id: "lightning", label: "LIGHTNING" },
    { id: "teenpatti", label: "TEENPATTI" },
    { id: "baccarat", label: "BACCARAT" },
    { id: "sicbo", label: "SICBO" },
    { id: "lucky7", label: "LUCKY7" },
    { id: "roulette", label: "ROULETTE" },
    { id: "poker", label: "POKER" },
    { id: "andar-bahar", label: "ANDAR BAHAR" },
  ],

  "mac88-fun-games": [
    { id: "all", label: "ALL" },
    { id: "aviator", label: "AVIATOR" },
    { id: "others", label: "OTHERS" },
    { id: "crash", label: "CRASH" },
    { id: "fun-games", label: "FUN GAMES" },
    { id: "slots", label: "SLOTS" },
    { id: "mines", label: "MINES" },
    { id: "hi-low", label: "HI LOW" },
    { id: "blackjack", label: "BLACKJACK" },
  ],

  "mac88-virtuals": [
    { id: "all", label: "ALL" },
    { id: "others", label: "OTHERS" },
    { id: "sports", label: "SPORTS" },
  ],

  "mac88-live-prediction": [
    { id: "all", label: "ALL" },
    { id: "others", label: "OTHERS" },
    { id: "cricket", label: "CRICKET" },
    { id: "race", label: "RACE" },
  ],

  macsexy: [
    { id: "all", label: "ALL" },
    { id: "roulette", label: "ROULETTE" },
    { id: "baccarat", label: "BACCARAT" },
    { id: "andar-bahar", label: "ANDARBAHAR" },
  ],

  color: [
    { id: "all", label: "ALL" },
    { id: "others", label: "OTHERS" },
  ],
};

const includesAny = (value, words) =>
  words.some((word) => value.includes(word));

const matchesProvider = (game, provider) => {
  if (provider === "all") {
    return true;
  }

  return game.desktopProviders?.includes(provider) || false;
};

const matchesGameType = (game, gameType) => {
  if (gameType === "all") {
    return true;
  }

  return game.desktopTypes?.includes(gameType) || false;
};

const DesktopCasino = () => {
  const navigate = useNavigate();
  const userInfo = Helper();

  const [searchText, setSearchText] = useState("");
  const [activeProvider, setActiveProvider] = useState("all");
  const [activeGameType, setActiveGameType] = useState("others");
  const [launchingGameId, setLaunchingGameId] = useState(null);

  const activeGameTypeTabs =
    gameTypeTabsByProvider[activeProvider] || gameTypeTabsByProvider.all;

  const visibleGames = useMemo(() => {
    const keyword = searchText.trim().toLowerCase();

    return casinoGames.filter((game) => {
      const matchesSearch =
        !keyword || game.name.toLowerCase().includes(keyword);

      return (
        matchesSearch &&
        matchesProvider(game, activeProvider) &&
        matchesGameType(game, activeGameType)
      );
    });
  }, [activeGameType, activeProvider, searchText]);

  const openGame = async (game) => {
    if (!userInfo?._id) {
      toast.error("Please login to play this game.", {
        autoClose: 2000,
      });

      navigate("/login");
      return;
    }

    setLaunchingGameId(game.id);

    try {
      const response = await axios({
        method: "post",
        url: `${Appconfig.casinoUrl}wco/login`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          user_id: userInfo._id,
          user_name: userInfo.user_name,
          redirect_url: "https://daddyexch.live/",
          provider_code: game.providerCode,
          game_code: game.gameCode,
          type: game.type ?? null,
        },
      });

      const status = response?.data?.status?.code;
      const launchURL = response?.data?.launchURL;

      if (status === "SUCCESS" && launchURL) {
        window.location.assign(launchURL);
        return;
      }

      toast.error(
        response?.data?.status?.message || "Unable to launch this game.",
        {
          autoClose: 2000,
        },
      );
    } catch (error) {
      toast.error(
        error?.response?.data?.status?.message ||
          "Unable to launch casino game.",
        {
          autoClose: 2000,
        },
      );
    } finally {
      setLaunchingGameId(null);
    }
  };

  return (
    <section className="desktop-casino-section" aria-label="Casino games">
      <div className="desktop-casino-heading">
        <h2>CASINO</h2>

        <label className="desktop-casino-search">
          <input
            type="search"
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
            placeholder="Search Games..."
            aria-label="Search casino games"
          />

          <span aria-hidden="true">⌕</span>
        </label>
      </div>

      <div className="desktop-casino-tabs-wrap">
        <div className="desktop-casino-tabs">
          {providerTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={
                activeProvider === tab.id
                  ? "desktop-casino-tab active"
                  : "desktop-casino-tab"
              }
              onClick={() => {
                setActiveProvider(tab.id);

                const firstGameType =
                  gameTypeTabsByProvider[tab.id]?.[0]?.id || "others";

                setActiveGameType(firstGameType);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="desktop-casino-tabs-wrap desktop-casino-tabs-wrap-second">
        <div className="desktop-casino-tabs">
          {activeGameTypeTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={
                activeGameType === tab.id
                  ? "desktop-casino-tab active"
                  : "desktop-casino-tab"
              }
              onClick={() => setActiveGameType(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {visibleGames.length > 0 ? (
        <div className="desktop-casino-games-grid">
          {visibleGames.map((game) => (
            <button
              key={game.id}
              type="button"
              className={[
                "desktop-casino-game-card",
                launchingGameId === game.id ? "is-launching" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => openGame(game)}
              disabled={launchingGameId !== null}
              title={`Play ${game.name}`}
            >
              <img
                src={
                  game.desktopImage
                    ? `${process.env.PUBLIC_URL}/Images/desktopcasino/${game.desktopImage}`
                    : `${process.env.PUBLIC_URL}/Images/casino-games/${game.image}`
                }
                alt={game.name}
                loading="lazy"
                draggable="false"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = `${process.env.PUBLIC_URL}/Images/casino-games/default.webp`;
                }}
              />

              <span className="desktop-casino-play-now">
                {launchingGameId === game.id ? "Loading..." : "Play Now"}
              </span>
            </button>
          ))}
        </div>
      ) : (
        <div className="desktop-casino-empty">
          No games found for this filter.
        </div>
      )}
    </section>
  );
};

export default DesktopCasino;
